import { createSlice } from "@reduxjs/toolkit";

// UI state only. The filters are read from the URL (`hooks/useTaskListFilters.ts`) and the rows come
// from React Query (`hooks/useTaskList.ts`), so neither lives here any more.
const TaskListInitialState: {
	assetCodes: any;
	selectedRow: any | null;
	openDialogLinkAttachmentToWo: boolean;
	openWorkOrderEditModal: boolean;
	openCommentsModal: boolean;
	openCloseWorkOrderModal: boolean;
	openDeleteWorkOrderModal: boolean;
	selectedFilesToAdd: File[];
	workOrderSelectedId: number | null;
	workOrderSelectedName: string | null;
	addAttachmentsFromVeiwer: boolean;
} = {
	assetCodes: {},
	selectedRow: null,
	openWorkOrderEditModal: false,
	openCommentsModal: false,
	openCloseWorkOrderModal: false,
	openDeleteWorkOrderModal: false,
	openDialogLinkAttachmentToWo: false,
	selectedFilesToAdd: [],
	workOrderSelectedId: null,
	workOrderSelectedName: null,
	addAttachmentsFromVeiwer: false,
};

export const TaskListReducer = createSlice({
	name: "__",
	initialState: TaskListInitialState,
	reducers: {
		setSelectedRow(state, { payload }) {
			state.selectedRow = payload;
		},
		setAssetCodes(state, { payload }) {
			state.assetCodes = payload;
		},
		setOpenWorkOrderEditModal(state, { payload }) {
			state.openWorkOrderEditModal = payload;
		},
		setOpenCommentsModal(state, { payload }) {
			state.openCommentsModal = payload;
		},
		setOpenCloseWorkOrderModal(state, { payload }) {
			state.openCloseWorkOrderModal = payload;
		},
		setOpenDeleteWorkOrderModal(state, { payload }) {
			state.openDeleteWorkOrderModal = payload;
		},
		setWorkOrderSelectedName(state, { payload }) {
			state.workOrderSelectedName = payload;
		},
		setOpenDialogLinkAttachmentToWO(state, { payload }) {
			state.openDialogLinkAttachmentToWo = payload;
		},
		setSelectedFilesToAdd(state, { payload }) {
			state.selectedFilesToAdd = payload;
		},
		setWorkOrderSelectedId(state, { payload }) {
			state.workOrderSelectedId = payload;
		},
		setAddAttachmentsFromVeiwer(state, { payload }) {
			state.addAttachmentsFromVeiwer = payload;
		},
	},
});
